import { render, staticRenderFns } from "./StampExchange.vue?vue&type=template&id=6608b99c&scoped=true&"
import script from "./StampExchange.vue?vue&type=script&lang=js&"
export * from "./StampExchange.vue?vue&type=script&lang=js&"
import style0 from "./StampExchange.vue?vue&type=style&index=0&id=6608b99c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6608b99c",
  null
  
)

export default component.exports